// extracted by mini-css-extract-plugin
export var title = "title-module--title--oQFAC";
export var smMargin = "title-module--smMargin--3cwsu";
export var hasSub = "title-module--hasSub--2VCfL";
export var more = "title-module--more--YET0O";